import React, { type FC } from 'react'

type MetaImageProps = {
  title?: string
  url?: string
}

export const MetaImage: FC<MetaImageProps> = ({ title, url }) => (
  <>
    {Boolean(url) && (
      <>
        <meta content={url} name="og:image" />
        <meta content={url} name="twitter:image" />
      </>
    )}
    {Boolean(title) && <meta content={title} name="twitter:image:alt" />}
  </>
)
